// extracted by mini-css-extract-plugin
export default {"card":"Card_card__gZz1M","image":"Card_image__DhxGy","name":"Card_name__kHrV0","title":"Card_title__yGD6v"};